import { ReactNode } from 'react';
import styled from '@emotion/styled';

// A centered single-card layout for the lightweight auth pages (forgot/reset
// password). Login keeps its own full hero layout; these don't need it.

const Screen = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(8)};
  background: ${({ theme }) => theme.background.secondary};
`;

const Card = styled.div`
  width: 100%;
  max-width: 380px;
  background: ${({ theme }) => theme.background.primary};
  border: 1px solid ${({ theme }) => theme.border.color.light};
  border-radius: ${({ theme }) => theme.border.radius.md};
  padding: ${({ theme }) => theme.spacing(10)};
`;

const Brand = styled.div`
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.font.color.tertiary};
  margin-bottom: ${({ theme }) => theme.spacing(6)};
`;

const Heading = styled.h1`
  font-size: ${({ theme }) => theme.font.size.xl};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  color: ${({ theme }) => theme.font.color.primary};
  margin: 0 0 ${({ theme }) => theme.spacing(2)} 0;
`;

const Sub = styled.p`
  font-size: ${({ theme }) => theme.font.size.sm};
  color: ${({ theme }) => theme.font.color.tertiary};
  margin: 0 0 ${({ theme }) => theme.spacing(7)} 0;
  line-height: 1.5;
`;

interface AuthScreenProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export function AuthScreen({ title, subtitle, children }: AuthScreenProps) {
  return (
    <Screen>
      <Card>
        <Brand>Simkura</Brand>
        <Heading>{title}</Heading>
        {subtitle && <Sub>{subtitle}</Sub>}
        {children}
      </Card>
    </Screen>
  );
}

export default AuthScreen;
